import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=cb86dc42"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"
import style0 from "./Brands.vue?vue&type=style&index=0&id=cb86dc42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports